<template>
  <Modal
    v-model="modalOpened"
    width="400"
    :mask-closable="uploadStatus !== 'uploading'"
  >
    <p slot="header">
      <Icon type="ios-cloud-upload-outline" />
      <span style="margin-left: 8px">导入权责表</span>
    </p>
    <input
      type="file"
      name="file"
      id="file"
      class="inputfile"
      @change="handlerUpload($event)"
      ref="inputFile"
    />
    <div v-if="importQZfile">
      <div>已添加</div>
      <div class="importQZfileList">
        <div>{{ importQZfile.name }}</div>
        <Button
          class="delInportfile"
          shape="circle"
          type="error"
          @click="delInportfile"
        >
          <Icon type="ios-close" />
        </Button>
      </div>
    </div>
    <label style="margin-top: 12px" class="custom-file-upload" for="file"
      >导入表格</label
    >
    <TimelineItem v-if="uploadStatus">
      <p class="time">上传进度</p>

      <Alert :type="alertStatus" style="margin-top: 12px;white-space: pre-line;">
        {{ uploadText }}
      </Alert>
      <Progress :percent="completeProgress" :status="progressBarStatus" />
    </TimelineItem>
    <div slot="footer">
      <Button @click="modalOpened = false">取消</Button>
      <Button
        type="primary"
        :disabled="uploadStatus === 'uploading'"
        :loading="uploadStatus === 'uploading'"
        @click="confirmImport"
        >确认上传</Button
      >
    </div>
  </Modal>
</template>

<script>
import { baseURL } from "@/utils/axios";
import { mapActions } from "vuex";
import axios from "axios";
import dayjs from "dayjs";

export default {
  name: "ImportARTableModal",
  props: {},
  components: {},
  data() {
    return {
      modalOpened: false,
      confirmBtnLoading: false,
      importQZfile: undefined,
      completeProgress: 0,
      progressBarStatus: undefined,
      uploadStatus: undefined, // enum: [undefined, 'uploading', 'success', 'error']
      uploadText: "未上传",
      fileDate: null,
      exportItem: {
        fileYear: null,
        fileMonth: null,
      },
      param: null,
    };
  },
  computed: {
    alertStatus: function () {
      switch (this.uploadStatus) {
        case "uploading":
          return "info";
        case "success":
          return "success";
        case "error":
          return "error";
        default:
          return "info";
      }
    },
  },
  methods: {
    async openModal(spo) {
      Object.assign(this.$data, this.$options.data());
      this.modalOpened = true;
    },
    handlerUpload: function (e) {
      //获取选定的文件
      this.importQZfile = e.target.files[0];
      this.param = new FormData();

      this.param.append("file", this.importQZfile);
      // if (!this.checkFileSize(this.importQZfile.size)) {
      //   this.uploadStatus = "error";
      //   return (this.uploadText = "文件体积必须小于7M");
      // }
      if (!this.checkFileType(this.importQZfile.name.split(".")[1])) {
        this.uploadStatus = "error";
        return (this.uploadText = "只支持.xls .xlsx格式");
      }
    },
    delInportfile() {
      this.importQZfile = null;
    },
    confirmImport() {
      this.uploadText = "上传中...";
      this.progressBarStatus = null;
      this.uploadStatus = "uploading";
      var that = this;
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (e) => {
          that.completeProgress = ((e.loaded / e.total) * 100) | 0;
        },
      };

      axios.interceptors.request.use(
        function (config) {
          // Do something before request is sent
          let token = localStorage.getItem("token");
          // ;
          config.headers["token"] = token;
          return config;
        },
        function (error) {
          // Do something with request error
          return Promise.reject(error.response.data);
        }
      );
      axios
        .post(`${baseURL}/import_customer_qz_table`, this.param, config)
        .then(function (response) {
          that.uploadStatus = "success";
          that.uploadText = "导入成功";
          that.$refs.inputFile.value = null;
          // that.$emit("uploadSuccess");
          const { missCustomerName, missDepartment, missUser } = response.data.data;
          const missCustomerNameText = missCustomerName.length > 0 ? `部分客户找不到： \n${missCustomerName.join('\n')}\n` : '';
          const missDepartmentText = missDepartment.length > 0 ? `部分客户没有部门： \n${missDepartment.join('\n')}\n` : '';
          const missUserText = missUser.length > 0 ? `部分用户找不到： \n${missUser.join('\n')}\n` : '';
          that.uploadText = `${missCustomerNameText}${missDepartmentText}${missUserText}`;
          if (that.uploadText === '') {
            that.uploadText = "导入成功"
            that.$Message.info('导入成功');
            that.modalOpened = false;
          }
        })
        .catch(function (error) {
          that.uploadStatus = "error";
          that.uploadText = `上传错误：${error}`;
          that.progressBarStatus = "wrong";
          that.$refs.inputFile.value = null;
        });
    },
    formatFileSize: function (fileSize, idx) {
      var units = ["B", "KB", "MB", "GB"];
      idx = idx || 0;
      if (fileSize < 1024 || idx === units.length - 1) {
        return fileSize.toFixed(1) + units[idx];
      }
      return this.formatFileSize(fileSize / 1024, ++idx);
    },
    checkFileType: function (fileType) {
      return ["xls", "xlsx"].includes(fileType);
    },
    checkFileSize: function (fileSize) {
      return fileSize < 7 * 1024 * 1024; // 7M
    },
  },
  created() {},
};
</script>

<style scoped lang="stylus">
.inputfile
  // display: none;
  width 0.1px
  height 0.1px
  opacity 0
  overflow hidden
  position absolute
  z-index -1

.tip
  color red

.custom-file-upload
  border 1px solid rgb(220, 222, 226)
  display inline-block
  padding 6px 12px
  margin-right 12px
  cursor pointer
  font-size 12px
  border-radius 4px
  user-select none
  touch-action manipulation
  color #515a6e
  transition color 0.2s linear, background-color 0.2s linear, border 0.2s linear, box-shadow 0.2s linear, -webkit-box-shadow 0.2s linear

.inputfile + label:hover
  color #0c89f0
  border-color #0c89f0

.importQZfileList
  display flex

.delInportfile
  position relative
  padding 0
  width 14px
  height 14px
  margin 4px

  .ivu-icon
    position absolute
    top -1px
    left -1px
</style>
